import React from 'react'
import { CustomModal, TamanhoModalEnum } from 'mp-react-components'
import { NotificationTypeEnumerated } from '../../interfaces/notificationTypeEnumerated'
import problema from '../../images/Problema.jpg'
import sucesso from '../../images/Sucesso.jpg'
import Icon from '@mdi/react'
import { mdiThumbUp } from '@mdi/js'
import './style.scss'

interface NotificationModalProps {
  open: boolean
  title: string
  text: string | React.ReactNode
  type: NotificationTypeEnumerated
  onClose: () => void
}

const NotificationModal: React.FC<NotificationModalProps> = ({
  open,
  title,
  text,
  type,
  onClose
}) => {
  const typeToImageMap: Record<NotificationTypeEnumerated, string> = {
    [NotificationTypeEnumerated.SUCCESS]: sucesso,
    [NotificationTypeEnumerated.DANGER]: problema,
    [NotificationTypeEnumerated.INFO]: problema,
    [NotificationTypeEnumerated.WARNING]: problema,
  }

  return (
    <CustomModal
      show={open}
      size={TamanhoModalEnum.SMALL}
      title=''
      onClose={onClose}
    >
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            width: '100%'
          }}>
          <button
            aria-label="Fechar notificação"
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '30px',
              color: '#702826',
              cursor: 'pointer',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold'
            }}
          >
            ×
          </button>
        </div>

      <div style={{
        display: 'flex',
        alignItems: 'stretch',
        overflow: 'hidden'
      }}>
        <div style={{
          width: '200px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRight: '1px solid rgb(58 58 58)'
        }}>
          <img
            src={typeToImageMap[type]}
            alt={type}
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: '150px',
              objectFit: 'contain',
            }}
          />
        </div>

        <div style={{
          flex: 1,
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}>
          <h2 style={{
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#702826',
            margin: '0 0 16px 0',
            fontFamily: 'Arial, sans-serif'
          }}>
            {title}
          </h2>
          <div
            style={{
              fontSize: '14px',
              color: '#666666',
              lineHeight: '1.5',
              whiteSpace: 'pre-line',
              fontFamily: 'Arial, sans-serif',
              marginBottom: '20px'
            }}
          >
            {text}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
            <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '0',
                fontFamily: 'Arial, sans-serif'
              }}
            >
              <Icon
                path={mdiThumbUp}
                size={1.2}
                color="#702826"
              />
              <span style={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#333333'
              }}>
                Ok, entendi!
              </span>
            </button>
          </div>
        </div>
      </div>
    </CustomModal>
  )
}

export default NotificationModal
